/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createServerRootRoute } from '@tanstack/react-start/server'

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProtectedRouteImport } from './routes/protected'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as QtiStimulusEmbedIndexRouteImport } from './routes/qti-stimulus-embed/index'
import { Route as QtiEmbedIndexRouteImport } from './routes/qti-embed/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as QtiStimulusEmbedQtiIdRouteImport } from './routes/qti-stimulus-embed/$qtiId'
import { Route as QtiEmbedQtiIdRouteImport } from './routes/qti-embed/$qtiId'
import { Route as AdminRosterRouteImport } from './routes/admin/roster'
import { Route as AdminQtiTestRenderRouteImport } from './routes/admin/qti-test-render'
import { Route as AdminQtiStimulusRenderRouteImport } from './routes/admin/qti-stimulus-render'
import { Route as AdminQtiRenderTestRouteImport } from './routes/admin/qti-render-test'
import { Route as AdminPlacementsRouteImport } from './routes/admin/placements'
import { Route as AdminLessonRouteImport } from './routes/admin/lesson'
import { Route as AdminCourseProgressRouteImport } from './routes/admin/course-progress'
import { Route as AppAppRouteRouteImport } from './routes/_app/app/route'
import { Route as AdminCaseStandardsIndexRouteImport } from './routes/admin/case-standards/index'
import { Route as AppAppIndexRouteImport } from './routes/_app/app/index'
import { Route as AdminCaseStandardsDocumentIdRouteImport } from './routes/admin/case-standards/$documentId'
import { Route as AppAppWeekReportRouteImport } from './routes/_app/app/week-report'
import { Route as AppAppStudentXpReportRouteImport } from './routes/_app/app/student-xp-report'
import { Route as AppAppStudentPlacementReportRouteImport } from './routes/_app/app/student-placement-report'
import { Route as AppAppSessionReportRouteImport } from './routes/_app/app/session-report'
import { Route as AppAppPlacementsOldRouteImport } from './routes/_app/app/placements-old'
import { Route as AppAppPlacementsRouteImport } from './routes/_app/app/placements'
import { Route as AppAppOverall_students_subject_reportRouteImport } from './routes/_app/app/overall_students_subject_report'
import { Route as AppAppMyLearningReportRouteImport } from './routes/_app/app/my-learning-report'
import { Route as AppAppMonthReportRouteImport } from './routes/_app/app/month-report'
import { Route as AppAppMap_actuals_reportRouteImport } from './routes/_app/app/map_actuals_report'
import { Route as AppAppMapTestRouteImport } from './routes/_app/app/map-test'
import { Route as AppAppMapProfileRouteImport } from './routes/_app/app/map-profile'
import { Route as AppAppMapGrowthReportRouteImport } from './routes/_app/app/map-growth-report'
import { Route as AppAppLearningMetricsRouteImport } from './routes/_app/app/learning-metrics'
import { Route as AppAppDailyMetricsRouteImport } from './routes/_app/app/daily-metrics'
import { Route as AppAppCoursesRouteImport } from './routes/_app/app/courses'
import { Route as AppAppLessonLessonIdRouteImport } from './routes/_app/app/lesson.$lessonId'
import { Route as AppAppAdminSectionTestAssignmentsRouteImport } from './routes/_app/app/admin-section/test-assignments'
import { Route as AppAppAdminSectionSubjectTracksRouteImport } from './routes/_app/app/admin-section/subject-tracks'
import { Route as AppAppAdminSectionRosterRouteImport } from './routes/_app/app/admin-section/roster'
import { Route as AppAppAdminSectionOnboardingRouteImport } from './routes/_app/app/admin-section/onboarding'
import { Route as AppAppAdminSectionManualXpRouteImport } from './routes/_app/app/admin-section/manual-xp'
import { Route as AppAppAdminSectionCredentialsRouteImport } from './routes/_app/app/admin-section/credentials'
import { Route as AppAppAdminSectionUsersIndexRouteImport } from './routes/_app/app/admin-section/users/index'
import { Route as AppAppAdminSectionOrgsIndexRouteImport } from './routes/_app/app/admin-section/orgs/index'
import { Route as AppAppAdminSectionManageEnrollmentsIndexRouteImport } from './routes/_app/app/admin-section/manage-enrollments/index'
import { Route as AppAppAdminSectionManageCoursesIndexRouteImport } from './routes/_app/app/admin-section/manage-courses/index'
import { Route as AppAppAdminSectionUsersSourcedIdRouteImport } from './routes/_app/app/admin-section/users/$sourcedId'
import { Route as AppAppAdminSectionOrgsSourcedIdRouteImport } from './routes/_app/app/admin-section/orgs/$sourcedId'
import { Route as AppAppAdminSectionManageCoursesCreateRouteImport } from './routes/_app/app/admin-section/manage-courses/create'
import { Route as AppAppAdminSectionManageCoursesSourcedIdRouteImport } from './routes/_app/app/admin-section/manage-courses/$sourcedId'
import { ServerRoute as ApiAuthResetPasswordServerRouteImport } from './routes/api/auth/reset-password'
import { ServerRoute as ApiAuthLogoutServerRouteImport } from './routes/api/auth/logout'
import { ServerRoute as ApiAuthLoginServerRouteImport } from './routes/api/auth/login'
import { ServerRoute as ApiAuthCallbackServerRouteImport } from './routes/api/auth/callback'

const rootServerRouteImport = createServerRootRoute()

const ProtectedRoute = ProtectedRouteImport.update({
  id: '/protected',
  path: '/protected',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const QtiStimulusEmbedIndexRoute = QtiStimulusEmbedIndexRouteImport.update({
  id: '/qti-stimulus-embed/',
  path: '/qti-stimulus-embed/',
  getParentRoute: () => rootRouteImport,
} as any)
const QtiEmbedIndexRoute = QtiEmbedIndexRouteImport.update({
  id: '/qti-embed/',
  path: '/qti-embed/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const QtiStimulusEmbedQtiIdRoute = QtiStimulusEmbedQtiIdRouteImport.update({
  id: '/qti-stimulus-embed/$qtiId',
  path: '/qti-stimulus-embed/$qtiId',
  getParentRoute: () => rootRouteImport,
} as any)
const QtiEmbedQtiIdRoute = QtiEmbedQtiIdRouteImport.update({
  id: '/qti-embed/$qtiId',
  path: '/qti-embed/$qtiId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRosterRoute = AdminRosterRouteImport.update({
  id: '/roster',
  path: '/roster',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminQtiTestRenderRoute = AdminQtiTestRenderRouteImport.update({
  id: '/qti-test-render',
  path: '/qti-test-render',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminQtiStimulusRenderRoute = AdminQtiStimulusRenderRouteImport.update({
  id: '/qti-stimulus-render',
  path: '/qti-stimulus-render',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminQtiRenderTestRoute = AdminQtiRenderTestRouteImport.update({
  id: '/qti-render-test',
  path: '/qti-render-test',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPlacementsRoute = AdminPlacementsRouteImport.update({
  id: '/placements',
  path: '/placements',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminLessonRoute = AdminLessonRouteImport.update({
  id: '/lesson',
  path: '/lesson',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminCourseProgressRoute = AdminCourseProgressRouteImport.update({
  id: '/course-progress',
  path: '/course-progress',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AppAppRouteRoute = AppAppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => AppRouteRoute,
} as any)
const AdminCaseStandardsIndexRoute = AdminCaseStandardsIndexRouteImport.update({
  id: '/case-standards/',
  path: '/case-standards/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AppAppIndexRoute = AppAppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAppRouteRoute,
} as any)
const AdminCaseStandardsDocumentIdRoute =
  AdminCaseStandardsDocumentIdRouteImport.update({
    id: '/case-standards/$documentId',
    path: '/case-standards/$documentId',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AppAppWeekReportRoute = AppAppWeekReportRouteImport.update({
  id: '/week-report',
  path: '/week-report',
  getParentRoute: () => AppAppRouteRoute,
} as any)
const AppAppStudentXpReportRoute = AppAppStudentXpReportRouteImport.update({
  id: '/student-xp-report',
  path: '/student-xp-report',
  getParentRoute: () => AppAppRouteRoute,
} as any)
const AppAppStudentPlacementReportRoute =
  AppAppStudentPlacementReportRouteImport.update({
    id: '/student-placement-report',
    path: '/student-placement-report',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const AppAppSessionReportRoute = AppAppSessionReportRouteImport.update({
  id: '/session-report',
  path: '/session-report',
  getParentRoute: () => AppAppRouteRoute,
} as any)
const AppAppPlacementsOldRoute = AppAppPlacementsOldRouteImport.update({
  id: '/placements-old',
  path: '/placements-old',
  getParentRoute: () => AppAppRouteRoute,
} as any)
const AppAppPlacementsRoute = AppAppPlacementsRouteImport.update({
  id: '/placements',
  path: '/placements',
  getParentRoute: () => AppAppRouteRoute,
} as any)
const AppAppOverall_students_subject_reportRoute =
  AppAppOverall_students_subject_reportRouteImport.update({
    id: '/overall_students_subject_report',
    path: '/overall_students_subject_report',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const AppAppMyLearningReportRoute = AppAppMyLearningReportRouteImport.update({
  id: '/my-learning-report',
  path: '/my-learning-report',
  getParentRoute: () => AppAppRouteRoute,
} as any)
const AppAppMonthReportRoute = AppAppMonthReportRouteImport.update({
  id: '/month-report',
  path: '/month-report',
  getParentRoute: () => AppAppRouteRoute,
} as any)
const AppAppMap_actuals_reportRoute =
  AppAppMap_actuals_reportRouteImport.update({
    id: '/map_actuals_report',
    path: '/map_actuals_report',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const AppAppMapTestRoute = AppAppMapTestRouteImport.update({
  id: '/map-test',
  path: '/map-test',
  getParentRoute: () => AppAppRouteRoute,
} as any)
const AppAppMapProfileRoute = AppAppMapProfileRouteImport.update({
  id: '/map-profile',
  path: '/map-profile',
  getParentRoute: () => AppAppRouteRoute,
} as any)
const AppAppMapGrowthReportRoute = AppAppMapGrowthReportRouteImport.update({
  id: '/map-growth-report',
  path: '/map-growth-report',
  getParentRoute: () => AppAppRouteRoute,
} as any)
const AppAppLearningMetricsRoute = AppAppLearningMetricsRouteImport.update({
  id: '/learning-metrics',
  path: '/learning-metrics',
  getParentRoute: () => AppAppRouteRoute,
} as any)
const AppAppDailyMetricsRoute = AppAppDailyMetricsRouteImport.update({
  id: '/daily-metrics',
  path: '/daily-metrics',
  getParentRoute: () => AppAppRouteRoute,
} as any)
const AppAppCoursesRoute = AppAppCoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => AppAppRouteRoute,
} as any)
const AppAppLessonLessonIdRoute = AppAppLessonLessonIdRouteImport.update({
  id: '/lesson/$lessonId',
  path: '/lesson/$lessonId',
  getParentRoute: () => AppAppRouteRoute,
} as any)
const AppAppAdminSectionTestAssignmentsRoute =
  AppAppAdminSectionTestAssignmentsRouteImport.update({
    id: '/admin-section/test-assignments',
    path: '/admin-section/test-assignments',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const AppAppAdminSectionSubjectTracksRoute =
  AppAppAdminSectionSubjectTracksRouteImport.update({
    id: '/admin-section/subject-tracks',
    path: '/admin-section/subject-tracks',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const AppAppAdminSectionRosterRoute =
  AppAppAdminSectionRosterRouteImport.update({
    id: '/admin-section/roster',
    path: '/admin-section/roster',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const AppAppAdminSectionOnboardingRoute =
  AppAppAdminSectionOnboardingRouteImport.update({
    id: '/admin-section/onboarding',
    path: '/admin-section/onboarding',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const AppAppAdminSectionManualXpRoute =
  AppAppAdminSectionManualXpRouteImport.update({
    id: '/admin-section/manual-xp',
    path: '/admin-section/manual-xp',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const AppAppAdminSectionCredentialsRoute =
  AppAppAdminSectionCredentialsRouteImport.update({
    id: '/admin-section/credentials',
    path: '/admin-section/credentials',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const AppAppAdminSectionUsersIndexRoute =
  AppAppAdminSectionUsersIndexRouteImport.update({
    id: '/admin-section/users/',
    path: '/admin-section/users/',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const AppAppAdminSectionOrgsIndexRoute =
  AppAppAdminSectionOrgsIndexRouteImport.update({
    id: '/admin-section/orgs/',
    path: '/admin-section/orgs/',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const AppAppAdminSectionManageEnrollmentsIndexRoute =
  AppAppAdminSectionManageEnrollmentsIndexRouteImport.update({
    id: '/admin-section/manage-enrollments/',
    path: '/admin-section/manage-enrollments/',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const AppAppAdminSectionManageCoursesIndexRoute =
  AppAppAdminSectionManageCoursesIndexRouteImport.update({
    id: '/admin-section/manage-courses/',
    path: '/admin-section/manage-courses/',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const AppAppAdminSectionUsersSourcedIdRoute =
  AppAppAdminSectionUsersSourcedIdRouteImport.update({
    id: '/admin-section/users/$sourcedId',
    path: '/admin-section/users/$sourcedId',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const AppAppAdminSectionOrgsSourcedIdRoute =
  AppAppAdminSectionOrgsSourcedIdRouteImport.update({
    id: '/admin-section/orgs/$sourcedId',
    path: '/admin-section/orgs/$sourcedId',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const AppAppAdminSectionManageCoursesCreateRoute =
  AppAppAdminSectionManageCoursesCreateRouteImport.update({
    id: '/admin-section/manage-courses/create',
    path: '/admin-section/manage-courses/create',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const AppAppAdminSectionManageCoursesSourcedIdRoute =
  AppAppAdminSectionManageCoursesSourcedIdRouteImport.update({
    id: '/admin-section/manage-courses/$sourcedId',
    path: '/admin-section/manage-courses/$sourcedId',
    getParentRoute: () => AppAppRouteRoute,
  } as any)
const ApiAuthResetPasswordServerRoute =
  ApiAuthResetPasswordServerRouteImport.update({
    id: '/api/auth/reset-password',
    path: '/api/auth/reset-password',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiAuthLogoutServerRoute = ApiAuthLogoutServerRouteImport.update({
  id: '/api/auth/logout',
  path: '/api/auth/logout',
  getParentRoute: () => rootServerRouteImport,
} as any)
const ApiAuthLoginServerRoute = ApiAuthLoginServerRouteImport.update({
  id: '/api/auth/login',
  path: '/api/auth/login',
  getParentRoute: () => rootServerRouteImport,
} as any)
const ApiAuthCallbackServerRoute = ApiAuthCallbackServerRouteImport.update({
  id: '/api/auth/callback',
  path: '/api/auth/callback',
  getParentRoute: () => rootServerRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/admin': typeof AdminRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/protected': typeof ProtectedRoute
  '/app': typeof AppAppRouteRouteWithChildren
  '/admin/course-progress': typeof AdminCourseProgressRoute
  '/admin/lesson': typeof AdminLessonRoute
  '/admin/placements': typeof AdminPlacementsRoute
  '/admin/qti-render-test': typeof AdminQtiRenderTestRoute
  '/admin/qti-stimulus-render': typeof AdminQtiStimulusRenderRoute
  '/admin/qti-test-render': typeof AdminQtiTestRenderRoute
  '/admin/roster': typeof AdminRosterRoute
  '/qti-embed/$qtiId': typeof QtiEmbedQtiIdRoute
  '/qti-stimulus-embed/$qtiId': typeof QtiStimulusEmbedQtiIdRoute
  '/': typeof AppIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/qti-embed': typeof QtiEmbedIndexRoute
  '/qti-stimulus-embed': typeof QtiStimulusEmbedIndexRoute
  '/app/courses': typeof AppAppCoursesRoute
  '/app/daily-metrics': typeof AppAppDailyMetricsRoute
  '/app/learning-metrics': typeof AppAppLearningMetricsRoute
  '/app/map-growth-report': typeof AppAppMapGrowthReportRoute
  '/app/map-profile': typeof AppAppMapProfileRoute
  '/app/map-test': typeof AppAppMapTestRoute
  '/app/map_actuals_report': typeof AppAppMap_actuals_reportRoute
  '/app/month-report': typeof AppAppMonthReportRoute
  '/app/my-learning-report': typeof AppAppMyLearningReportRoute
  '/app/overall_students_subject_report': typeof AppAppOverall_students_subject_reportRoute
  '/app/placements': typeof AppAppPlacementsRoute
  '/app/placements-old': typeof AppAppPlacementsOldRoute
  '/app/session-report': typeof AppAppSessionReportRoute
  '/app/student-placement-report': typeof AppAppStudentPlacementReportRoute
  '/app/student-xp-report': typeof AppAppStudentXpReportRoute
  '/app/week-report': typeof AppAppWeekReportRoute
  '/admin/case-standards/$documentId': typeof AdminCaseStandardsDocumentIdRoute
  '/app/': typeof AppAppIndexRoute
  '/admin/case-standards': typeof AdminCaseStandardsIndexRoute
  '/app/admin-section/credentials': typeof AppAppAdminSectionCredentialsRoute
  '/app/admin-section/manual-xp': typeof AppAppAdminSectionManualXpRoute
  '/app/admin-section/onboarding': typeof AppAppAdminSectionOnboardingRoute
  '/app/admin-section/roster': typeof AppAppAdminSectionRosterRoute
  '/app/admin-section/subject-tracks': typeof AppAppAdminSectionSubjectTracksRoute
  '/app/admin-section/test-assignments': typeof AppAppAdminSectionTestAssignmentsRoute
  '/app/lesson/$lessonId': typeof AppAppLessonLessonIdRoute
  '/app/admin-section/manage-courses/$sourcedId': typeof AppAppAdminSectionManageCoursesSourcedIdRoute
  '/app/admin-section/manage-courses/create': typeof AppAppAdminSectionManageCoursesCreateRoute
  '/app/admin-section/orgs/$sourcedId': typeof AppAppAdminSectionOrgsSourcedIdRoute
  '/app/admin-section/users/$sourcedId': typeof AppAppAdminSectionUsersSourcedIdRoute
  '/app/admin-section/manage-courses': typeof AppAppAdminSectionManageCoursesIndexRoute
  '/app/admin-section/manage-enrollments': typeof AppAppAdminSectionManageEnrollmentsIndexRoute
  '/app/admin-section/orgs': typeof AppAppAdminSectionOrgsIndexRoute
  '/app/admin-section/users': typeof AppAppAdminSectionUsersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/protected': typeof ProtectedRoute
  '/admin/course-progress': typeof AdminCourseProgressRoute
  '/admin/lesson': typeof AdminLessonRoute
  '/admin/placements': typeof AdminPlacementsRoute
  '/admin/qti-render-test': typeof AdminQtiRenderTestRoute
  '/admin/qti-stimulus-render': typeof AdminQtiStimulusRenderRoute
  '/admin/qti-test-render': typeof AdminQtiTestRenderRoute
  '/admin/roster': typeof AdminRosterRoute
  '/qti-embed/$qtiId': typeof QtiEmbedQtiIdRoute
  '/qti-stimulus-embed/$qtiId': typeof QtiStimulusEmbedQtiIdRoute
  '/': typeof AppIndexRoute
  '/admin': typeof AdminIndexRoute
  '/qti-embed': typeof QtiEmbedIndexRoute
  '/qti-stimulus-embed': typeof QtiStimulusEmbedIndexRoute
  '/app/courses': typeof AppAppCoursesRoute
  '/app/daily-metrics': typeof AppAppDailyMetricsRoute
  '/app/learning-metrics': typeof AppAppLearningMetricsRoute
  '/app/map-growth-report': typeof AppAppMapGrowthReportRoute
  '/app/map-profile': typeof AppAppMapProfileRoute
  '/app/map-test': typeof AppAppMapTestRoute
  '/app/map_actuals_report': typeof AppAppMap_actuals_reportRoute
  '/app/month-report': typeof AppAppMonthReportRoute
  '/app/my-learning-report': typeof AppAppMyLearningReportRoute
  '/app/overall_students_subject_report': typeof AppAppOverall_students_subject_reportRoute
  '/app/placements': typeof AppAppPlacementsRoute
  '/app/placements-old': typeof AppAppPlacementsOldRoute
  '/app/session-report': typeof AppAppSessionReportRoute
  '/app/student-placement-report': typeof AppAppStudentPlacementReportRoute
  '/app/student-xp-report': typeof AppAppStudentXpReportRoute
  '/app/week-report': typeof AppAppWeekReportRoute
  '/admin/case-standards/$documentId': typeof AdminCaseStandardsDocumentIdRoute
  '/app': typeof AppAppIndexRoute
  '/admin/case-standards': typeof AdminCaseStandardsIndexRoute
  '/app/admin-section/credentials': typeof AppAppAdminSectionCredentialsRoute
  '/app/admin-section/manual-xp': typeof AppAppAdminSectionManualXpRoute
  '/app/admin-section/onboarding': typeof AppAppAdminSectionOnboardingRoute
  '/app/admin-section/roster': typeof AppAppAdminSectionRosterRoute
  '/app/admin-section/subject-tracks': typeof AppAppAdminSectionSubjectTracksRoute
  '/app/admin-section/test-assignments': typeof AppAppAdminSectionTestAssignmentsRoute
  '/app/lesson/$lessonId': typeof AppAppLessonLessonIdRoute
  '/app/admin-section/manage-courses/$sourcedId': typeof AppAppAdminSectionManageCoursesSourcedIdRoute
  '/app/admin-section/manage-courses/create': typeof AppAppAdminSectionManageCoursesCreateRoute
  '/app/admin-section/orgs/$sourcedId': typeof AppAppAdminSectionOrgsSourcedIdRoute
  '/app/admin-section/users/$sourcedId': typeof AppAppAdminSectionUsersSourcedIdRoute
  '/app/admin-section/manage-courses': typeof AppAppAdminSectionManageCoursesIndexRoute
  '/app/admin-section/manage-enrollments': typeof AppAppAdminSectionManageEnrollmentsIndexRoute
  '/app/admin-section/orgs': typeof AppAppAdminSectionOrgsIndexRoute
  '/app/admin-section/users': typeof AppAppAdminSectionUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/admin': typeof AdminRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/protected': typeof ProtectedRoute
  '/_app/app': typeof AppAppRouteRouteWithChildren
  '/admin/course-progress': typeof AdminCourseProgressRoute
  '/admin/lesson': typeof AdminLessonRoute
  '/admin/placements': typeof AdminPlacementsRoute
  '/admin/qti-render-test': typeof AdminQtiRenderTestRoute
  '/admin/qti-stimulus-render': typeof AdminQtiStimulusRenderRoute
  '/admin/qti-test-render': typeof AdminQtiTestRenderRoute
  '/admin/roster': typeof AdminRosterRoute
  '/qti-embed/$qtiId': typeof QtiEmbedQtiIdRoute
  '/qti-stimulus-embed/$qtiId': typeof QtiStimulusEmbedQtiIdRoute
  '/_app/': typeof AppIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/qti-embed/': typeof QtiEmbedIndexRoute
  '/qti-stimulus-embed/': typeof QtiStimulusEmbedIndexRoute
  '/_app/app/courses': typeof AppAppCoursesRoute
  '/_app/app/daily-metrics': typeof AppAppDailyMetricsRoute
  '/_app/app/learning-metrics': typeof AppAppLearningMetricsRoute
  '/_app/app/map-growth-report': typeof AppAppMapGrowthReportRoute
  '/_app/app/map-profile': typeof AppAppMapProfileRoute
  '/_app/app/map-test': typeof AppAppMapTestRoute
  '/_app/app/map_actuals_report': typeof AppAppMap_actuals_reportRoute
  '/_app/app/month-report': typeof AppAppMonthReportRoute
  '/_app/app/my-learning-report': typeof AppAppMyLearningReportRoute
  '/_app/app/overall_students_subject_report': typeof AppAppOverall_students_subject_reportRoute
  '/_app/app/placements': typeof AppAppPlacementsRoute
  '/_app/app/placements-old': typeof AppAppPlacementsOldRoute
  '/_app/app/session-report': typeof AppAppSessionReportRoute
  '/_app/app/student-placement-report': typeof AppAppStudentPlacementReportRoute
  '/_app/app/student-xp-report': typeof AppAppStudentXpReportRoute
  '/_app/app/week-report': typeof AppAppWeekReportRoute
  '/admin/case-standards/$documentId': typeof AdminCaseStandardsDocumentIdRoute
  '/_app/app/': typeof AppAppIndexRoute
  '/admin/case-standards/': typeof AdminCaseStandardsIndexRoute
  '/_app/app/admin-section/credentials': typeof AppAppAdminSectionCredentialsRoute
  '/_app/app/admin-section/manual-xp': typeof AppAppAdminSectionManualXpRoute
  '/_app/app/admin-section/onboarding': typeof AppAppAdminSectionOnboardingRoute
  '/_app/app/admin-section/roster': typeof AppAppAdminSectionRosterRoute
  '/_app/app/admin-section/subject-tracks': typeof AppAppAdminSectionSubjectTracksRoute
  '/_app/app/admin-section/test-assignments': typeof AppAppAdminSectionTestAssignmentsRoute
  '/_app/app/lesson/$lessonId': typeof AppAppLessonLessonIdRoute
  '/_app/app/admin-section/manage-courses/$sourcedId': typeof AppAppAdminSectionManageCoursesSourcedIdRoute
  '/_app/app/admin-section/manage-courses/create': typeof AppAppAdminSectionManageCoursesCreateRoute
  '/_app/app/admin-section/orgs/$sourcedId': typeof AppAppAdminSectionOrgsSourcedIdRoute
  '/_app/app/admin-section/users/$sourcedId': typeof AppAppAdminSectionUsersSourcedIdRoute
  '/_app/app/admin-section/manage-courses/': typeof AppAppAdminSectionManageCoursesIndexRoute
  '/_app/app/admin-section/manage-enrollments/': typeof AppAppAdminSectionManageEnrollmentsIndexRoute
  '/_app/app/admin-section/orgs/': typeof AppAppAdminSectionOrgsIndexRoute
  '/_app/app/admin-section/users/': typeof AppAppAdminSectionUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/admin'
    | '/login'
    | '/protected'
    | '/app'
    | '/admin/course-progress'
    | '/admin/lesson'
    | '/admin/placements'
    | '/admin/qti-render-test'
    | '/admin/qti-stimulus-render'
    | '/admin/qti-test-render'
    | '/admin/roster'
    | '/qti-embed/$qtiId'
    | '/qti-stimulus-embed/$qtiId'
    | '/'
    | '/admin/'
    | '/qti-embed'
    | '/qti-stimulus-embed'
    | '/app/courses'
    | '/app/daily-metrics'
    | '/app/learning-metrics'
    | '/app/map-growth-report'
    | '/app/map-profile'
    | '/app/map-test'
    | '/app/map_actuals_report'
    | '/app/month-report'
    | '/app/my-learning-report'
    | '/app/overall_students_subject_report'
    | '/app/placements'
    | '/app/placements-old'
    | '/app/session-report'
    | '/app/student-placement-report'
    | '/app/student-xp-report'
    | '/app/week-report'
    | '/admin/case-standards/$documentId'
    | '/app/'
    | '/admin/case-standards'
    | '/app/admin-section/credentials'
    | '/app/admin-section/manual-xp'
    | '/app/admin-section/onboarding'
    | '/app/admin-section/roster'
    | '/app/admin-section/subject-tracks'
    | '/app/admin-section/test-assignments'
    | '/app/lesson/$lessonId'
    | '/app/admin-section/manage-courses/$sourcedId'
    | '/app/admin-section/manage-courses/create'
    | '/app/admin-section/orgs/$sourcedId'
    | '/app/admin-section/users/$sourcedId'
    | '/app/admin-section/manage-courses'
    | '/app/admin-section/manage-enrollments'
    | '/app/admin-section/orgs'
    | '/app/admin-section/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/protected'
    | '/admin/course-progress'
    | '/admin/lesson'
    | '/admin/placements'
    | '/admin/qti-render-test'
    | '/admin/qti-stimulus-render'
    | '/admin/qti-test-render'
    | '/admin/roster'
    | '/qti-embed/$qtiId'
    | '/qti-stimulus-embed/$qtiId'
    | '/'
    | '/admin'
    | '/qti-embed'
    | '/qti-stimulus-embed'
    | '/app/courses'
    | '/app/daily-metrics'
    | '/app/learning-metrics'
    | '/app/map-growth-report'
    | '/app/map-profile'
    | '/app/map-test'
    | '/app/map_actuals_report'
    | '/app/month-report'
    | '/app/my-learning-report'
    | '/app/overall_students_subject_report'
    | '/app/placements'
    | '/app/placements-old'
    | '/app/session-report'
    | '/app/student-placement-report'
    | '/app/student-xp-report'
    | '/app/week-report'
    | '/admin/case-standards/$documentId'
    | '/app'
    | '/admin/case-standards'
    | '/app/admin-section/credentials'
    | '/app/admin-section/manual-xp'
    | '/app/admin-section/onboarding'
    | '/app/admin-section/roster'
    | '/app/admin-section/subject-tracks'
    | '/app/admin-section/test-assignments'
    | '/app/lesson/$lessonId'
    | '/app/admin-section/manage-courses/$sourcedId'
    | '/app/admin-section/manage-courses/create'
    | '/app/admin-section/orgs/$sourcedId'
    | '/app/admin-section/users/$sourcedId'
    | '/app/admin-section/manage-courses'
    | '/app/admin-section/manage-enrollments'
    | '/app/admin-section/orgs'
    | '/app/admin-section/users'
  id:
    | '__root__'
    | '/_app'
    | '/admin'
    | '/login'
    | '/protected'
    | '/_app/app'
    | '/admin/course-progress'
    | '/admin/lesson'
    | '/admin/placements'
    | '/admin/qti-render-test'
    | '/admin/qti-stimulus-render'
    | '/admin/qti-test-render'
    | '/admin/roster'
    | '/qti-embed/$qtiId'
    | '/qti-stimulus-embed/$qtiId'
    | '/_app/'
    | '/admin/'
    | '/qti-embed/'
    | '/qti-stimulus-embed/'
    | '/_app/app/courses'
    | '/_app/app/daily-metrics'
    | '/_app/app/learning-metrics'
    | '/_app/app/map-growth-report'
    | '/_app/app/map-profile'
    | '/_app/app/map-test'
    | '/_app/app/map_actuals_report'
    | '/_app/app/month-report'
    | '/_app/app/my-learning-report'
    | '/_app/app/overall_students_subject_report'
    | '/_app/app/placements'
    | '/_app/app/placements-old'
    | '/_app/app/session-report'
    | '/_app/app/student-placement-report'
    | '/_app/app/student-xp-report'
    | '/_app/app/week-report'
    | '/admin/case-standards/$documentId'
    | '/_app/app/'
    | '/admin/case-standards/'
    | '/_app/app/admin-section/credentials'
    | '/_app/app/admin-section/manual-xp'
    | '/_app/app/admin-section/onboarding'
    | '/_app/app/admin-section/roster'
    | '/_app/app/admin-section/subject-tracks'
    | '/_app/app/admin-section/test-assignments'
    | '/_app/app/lesson/$lessonId'
    | '/_app/app/admin-section/manage-courses/$sourcedId'
    | '/_app/app/admin-section/manage-courses/create'
    | '/_app/app/admin-section/orgs/$sourcedId'
    | '/_app/app/admin-section/users/$sourcedId'
    | '/_app/app/admin-section/manage-courses/'
    | '/_app/app/admin-section/manage-enrollments/'
    | '/_app/app/admin-section/orgs/'
    | '/_app/app/admin-section/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  ProtectedRoute: typeof ProtectedRoute
  QtiEmbedQtiIdRoute: typeof QtiEmbedQtiIdRoute
  QtiStimulusEmbedQtiIdRoute: typeof QtiStimulusEmbedQtiIdRoute
  QtiEmbedIndexRoute: typeof QtiEmbedIndexRoute
  QtiStimulusEmbedIndexRoute: typeof QtiStimulusEmbedIndexRoute
}
export interface FileServerRoutesByFullPath {
  '/api/auth/callback': typeof ApiAuthCallbackServerRoute
  '/api/auth/login': typeof ApiAuthLoginServerRoute
  '/api/auth/logout': typeof ApiAuthLogoutServerRoute
  '/api/auth/reset-password': typeof ApiAuthResetPasswordServerRoute
}
export interface FileServerRoutesByTo {
  '/api/auth/callback': typeof ApiAuthCallbackServerRoute
  '/api/auth/login': typeof ApiAuthLoginServerRoute
  '/api/auth/logout': typeof ApiAuthLogoutServerRoute
  '/api/auth/reset-password': typeof ApiAuthResetPasswordServerRoute
}
export interface FileServerRoutesById {
  __root__: typeof rootServerRouteImport
  '/api/auth/callback': typeof ApiAuthCallbackServerRoute
  '/api/auth/login': typeof ApiAuthLoginServerRoute
  '/api/auth/logout': typeof ApiAuthLogoutServerRoute
  '/api/auth/reset-password': typeof ApiAuthResetPasswordServerRoute
}
export interface FileServerRouteTypes {
  fileServerRoutesByFullPath: FileServerRoutesByFullPath
  fullPaths:
    | '/api/auth/callback'
    | '/api/auth/login'
    | '/api/auth/logout'
    | '/api/auth/reset-password'
  fileServerRoutesByTo: FileServerRoutesByTo
  to:
    | '/api/auth/callback'
    | '/api/auth/login'
    | '/api/auth/logout'
    | '/api/auth/reset-password'
  id:
    | '__root__'
    | '/api/auth/callback'
    | '/api/auth/login'
    | '/api/auth/logout'
    | '/api/auth/reset-password'
  fileServerRoutesById: FileServerRoutesById
}
export interface RootServerRouteChildren {
  ApiAuthCallbackServerRoute: typeof ApiAuthCallbackServerRoute
  ApiAuthLoginServerRoute: typeof ApiAuthLoginServerRoute
  ApiAuthLogoutServerRoute: typeof ApiAuthLogoutServerRoute
  ApiAuthResetPasswordServerRoute: typeof ApiAuthResetPasswordServerRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/protected': {
      id: '/protected'
      path: '/protected'
      fullPath: '/protected'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qti-stimulus-embed/': {
      id: '/qti-stimulus-embed/'
      path: '/qti-stimulus-embed'
      fullPath: '/qti-stimulus-embed'
      preLoaderRoute: typeof QtiStimulusEmbedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qti-embed/': {
      id: '/qti-embed/'
      path: '/qti-embed'
      fullPath: '/qti-embed'
      preLoaderRoute: typeof QtiEmbedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/qti-stimulus-embed/$qtiId': {
      id: '/qti-stimulus-embed/$qtiId'
      path: '/qti-stimulus-embed/$qtiId'
      fullPath: '/qti-stimulus-embed/$qtiId'
      preLoaderRoute: typeof QtiStimulusEmbedQtiIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qti-embed/$qtiId': {
      id: '/qti-embed/$qtiId'
      path: '/qti-embed/$qtiId'
      fullPath: '/qti-embed/$qtiId'
      preLoaderRoute: typeof QtiEmbedQtiIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/roster': {
      id: '/admin/roster'
      path: '/roster'
      fullPath: '/admin/roster'
      preLoaderRoute: typeof AdminRosterRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/qti-test-render': {
      id: '/admin/qti-test-render'
      path: '/qti-test-render'
      fullPath: '/admin/qti-test-render'
      preLoaderRoute: typeof AdminQtiTestRenderRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/qti-stimulus-render': {
      id: '/admin/qti-stimulus-render'
      path: '/qti-stimulus-render'
      fullPath: '/admin/qti-stimulus-render'
      preLoaderRoute: typeof AdminQtiStimulusRenderRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/qti-render-test': {
      id: '/admin/qti-render-test'
      path: '/qti-render-test'
      fullPath: '/admin/qti-render-test'
      preLoaderRoute: typeof AdminQtiRenderTestRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/placements': {
      id: '/admin/placements'
      path: '/placements'
      fullPath: '/admin/placements'
      preLoaderRoute: typeof AdminPlacementsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/lesson': {
      id: '/admin/lesson'
      path: '/lesson'
      fullPath: '/admin/lesson'
      preLoaderRoute: typeof AdminLessonRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/course-progress': {
      id: '/admin/course-progress'
      path: '/course-progress'
      fullPath: '/admin/course-progress'
      preLoaderRoute: typeof AdminCourseProgressRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_app/app': {
      id: '/_app/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppAppRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/admin/case-standards/': {
      id: '/admin/case-standards/'
      path: '/case-standards'
      fullPath: '/admin/case-standards'
      preLoaderRoute: typeof AdminCaseStandardsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_app/app/': {
      id: '/_app/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppAppIndexRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/admin/case-standards/$documentId': {
      id: '/admin/case-standards/$documentId'
      path: '/case-standards/$documentId'
      fullPath: '/admin/case-standards/$documentId'
      preLoaderRoute: typeof AdminCaseStandardsDocumentIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_app/app/week-report': {
      id: '/_app/app/week-report'
      path: '/week-report'
      fullPath: '/app/week-report'
      preLoaderRoute: typeof AppAppWeekReportRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/student-xp-report': {
      id: '/_app/app/student-xp-report'
      path: '/student-xp-report'
      fullPath: '/app/student-xp-report'
      preLoaderRoute: typeof AppAppStudentXpReportRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/student-placement-report': {
      id: '/_app/app/student-placement-report'
      path: '/student-placement-report'
      fullPath: '/app/student-placement-report'
      preLoaderRoute: typeof AppAppStudentPlacementReportRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/session-report': {
      id: '/_app/app/session-report'
      path: '/session-report'
      fullPath: '/app/session-report'
      preLoaderRoute: typeof AppAppSessionReportRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/placements-old': {
      id: '/_app/app/placements-old'
      path: '/placements-old'
      fullPath: '/app/placements-old'
      preLoaderRoute: typeof AppAppPlacementsOldRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/placements': {
      id: '/_app/app/placements'
      path: '/placements'
      fullPath: '/app/placements'
      preLoaderRoute: typeof AppAppPlacementsRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/overall_students_subject_report': {
      id: '/_app/app/overall_students_subject_report'
      path: '/overall_students_subject_report'
      fullPath: '/app/overall_students_subject_report'
      preLoaderRoute: typeof AppAppOverall_students_subject_reportRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/my-learning-report': {
      id: '/_app/app/my-learning-report'
      path: '/my-learning-report'
      fullPath: '/app/my-learning-report'
      preLoaderRoute: typeof AppAppMyLearningReportRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/month-report': {
      id: '/_app/app/month-report'
      path: '/month-report'
      fullPath: '/app/month-report'
      preLoaderRoute: typeof AppAppMonthReportRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/map_actuals_report': {
      id: '/_app/app/map_actuals_report'
      path: '/map_actuals_report'
      fullPath: '/app/map_actuals_report'
      preLoaderRoute: typeof AppAppMap_actuals_reportRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/map-test': {
      id: '/_app/app/map-test'
      path: '/map-test'
      fullPath: '/app/map-test'
      preLoaderRoute: typeof AppAppMapTestRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/map-profile': {
      id: '/_app/app/map-profile'
      path: '/map-profile'
      fullPath: '/app/map-profile'
      preLoaderRoute: typeof AppAppMapProfileRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/map-growth-report': {
      id: '/_app/app/map-growth-report'
      path: '/map-growth-report'
      fullPath: '/app/map-growth-report'
      preLoaderRoute: typeof AppAppMapGrowthReportRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/learning-metrics': {
      id: '/_app/app/learning-metrics'
      path: '/learning-metrics'
      fullPath: '/app/learning-metrics'
      preLoaderRoute: typeof AppAppLearningMetricsRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/daily-metrics': {
      id: '/_app/app/daily-metrics'
      path: '/daily-metrics'
      fullPath: '/app/daily-metrics'
      preLoaderRoute: typeof AppAppDailyMetricsRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/courses': {
      id: '/_app/app/courses'
      path: '/courses'
      fullPath: '/app/courses'
      preLoaderRoute: typeof AppAppCoursesRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/lesson/$lessonId': {
      id: '/_app/app/lesson/$lessonId'
      path: '/lesson/$lessonId'
      fullPath: '/app/lesson/$lessonId'
      preLoaderRoute: typeof AppAppLessonLessonIdRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/admin-section/test-assignments': {
      id: '/_app/app/admin-section/test-assignments'
      path: '/admin-section/test-assignments'
      fullPath: '/app/admin-section/test-assignments'
      preLoaderRoute: typeof AppAppAdminSectionTestAssignmentsRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/admin-section/subject-tracks': {
      id: '/_app/app/admin-section/subject-tracks'
      path: '/admin-section/subject-tracks'
      fullPath: '/app/admin-section/subject-tracks'
      preLoaderRoute: typeof AppAppAdminSectionSubjectTracksRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/admin-section/roster': {
      id: '/_app/app/admin-section/roster'
      path: '/admin-section/roster'
      fullPath: '/app/admin-section/roster'
      preLoaderRoute: typeof AppAppAdminSectionRosterRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/admin-section/onboarding': {
      id: '/_app/app/admin-section/onboarding'
      path: '/admin-section/onboarding'
      fullPath: '/app/admin-section/onboarding'
      preLoaderRoute: typeof AppAppAdminSectionOnboardingRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/admin-section/manual-xp': {
      id: '/_app/app/admin-section/manual-xp'
      path: '/admin-section/manual-xp'
      fullPath: '/app/admin-section/manual-xp'
      preLoaderRoute: typeof AppAppAdminSectionManualXpRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/admin-section/credentials': {
      id: '/_app/app/admin-section/credentials'
      path: '/admin-section/credentials'
      fullPath: '/app/admin-section/credentials'
      preLoaderRoute: typeof AppAppAdminSectionCredentialsRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/admin-section/users/': {
      id: '/_app/app/admin-section/users/'
      path: '/admin-section/users'
      fullPath: '/app/admin-section/users'
      preLoaderRoute: typeof AppAppAdminSectionUsersIndexRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/admin-section/orgs/': {
      id: '/_app/app/admin-section/orgs/'
      path: '/admin-section/orgs'
      fullPath: '/app/admin-section/orgs'
      preLoaderRoute: typeof AppAppAdminSectionOrgsIndexRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/admin-section/manage-enrollments/': {
      id: '/_app/app/admin-section/manage-enrollments/'
      path: '/admin-section/manage-enrollments'
      fullPath: '/app/admin-section/manage-enrollments'
      preLoaderRoute: typeof AppAppAdminSectionManageEnrollmentsIndexRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/admin-section/manage-courses/': {
      id: '/_app/app/admin-section/manage-courses/'
      path: '/admin-section/manage-courses'
      fullPath: '/app/admin-section/manage-courses'
      preLoaderRoute: typeof AppAppAdminSectionManageCoursesIndexRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/admin-section/users/$sourcedId': {
      id: '/_app/app/admin-section/users/$sourcedId'
      path: '/admin-section/users/$sourcedId'
      fullPath: '/app/admin-section/users/$sourcedId'
      preLoaderRoute: typeof AppAppAdminSectionUsersSourcedIdRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/admin-section/orgs/$sourcedId': {
      id: '/_app/app/admin-section/orgs/$sourcedId'
      path: '/admin-section/orgs/$sourcedId'
      fullPath: '/app/admin-section/orgs/$sourcedId'
      preLoaderRoute: typeof AppAppAdminSectionOrgsSourcedIdRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/admin-section/manage-courses/create': {
      id: '/_app/app/admin-section/manage-courses/create'
      path: '/admin-section/manage-courses/create'
      fullPath: '/app/admin-section/manage-courses/create'
      preLoaderRoute: typeof AppAppAdminSectionManageCoursesCreateRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
    '/_app/app/admin-section/manage-courses/$sourcedId': {
      id: '/_app/app/admin-section/manage-courses/$sourcedId'
      path: '/admin-section/manage-courses/$sourcedId'
      fullPath: '/app/admin-section/manage-courses/$sourcedId'
      preLoaderRoute: typeof AppAppAdminSectionManageCoursesSourcedIdRouteImport
      parentRoute: typeof AppAppRouteRoute
    }
  }
}
declare module '@tanstack/react-start/server' {
  interface ServerFileRoutesByPath {
    '/api/auth/reset-password': {
      id: '/api/auth/reset-password'
      path: '/api/auth/reset-password'
      fullPath: '/api/auth/reset-password'
      preLoaderRoute: typeof ApiAuthResetPasswordServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/auth/logout': {
      id: '/api/auth/logout'
      path: '/api/auth/logout'
      fullPath: '/api/auth/logout'
      preLoaderRoute: typeof ApiAuthLogoutServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/auth/login': {
      id: '/api/auth/login'
      path: '/api/auth/login'
      fullPath: '/api/auth/login'
      preLoaderRoute: typeof ApiAuthLoginServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/auth/callback': {
      id: '/api/auth/callback'
      path: '/api/auth/callback'
      fullPath: '/api/auth/callback'
      preLoaderRoute: typeof ApiAuthCallbackServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
  }
}

interface AppAppRouteRouteChildren {
  AppAppCoursesRoute: typeof AppAppCoursesRoute
  AppAppDailyMetricsRoute: typeof AppAppDailyMetricsRoute
  AppAppLearningMetricsRoute: typeof AppAppLearningMetricsRoute
  AppAppMapGrowthReportRoute: typeof AppAppMapGrowthReportRoute
  AppAppMapProfileRoute: typeof AppAppMapProfileRoute
  AppAppMapTestRoute: typeof AppAppMapTestRoute
  AppAppMap_actuals_reportRoute: typeof AppAppMap_actuals_reportRoute
  AppAppMonthReportRoute: typeof AppAppMonthReportRoute
  AppAppMyLearningReportRoute: typeof AppAppMyLearningReportRoute
  AppAppOverall_students_subject_reportRoute: typeof AppAppOverall_students_subject_reportRoute
  AppAppPlacementsRoute: typeof AppAppPlacementsRoute
  AppAppPlacementsOldRoute: typeof AppAppPlacementsOldRoute
  AppAppSessionReportRoute: typeof AppAppSessionReportRoute
  AppAppStudentPlacementReportRoute: typeof AppAppStudentPlacementReportRoute
  AppAppStudentXpReportRoute: typeof AppAppStudentXpReportRoute
  AppAppWeekReportRoute: typeof AppAppWeekReportRoute
  AppAppIndexRoute: typeof AppAppIndexRoute
  AppAppAdminSectionCredentialsRoute: typeof AppAppAdminSectionCredentialsRoute
  AppAppAdminSectionManualXpRoute: typeof AppAppAdminSectionManualXpRoute
  AppAppAdminSectionOnboardingRoute: typeof AppAppAdminSectionOnboardingRoute
  AppAppAdminSectionRosterRoute: typeof AppAppAdminSectionRosterRoute
  AppAppAdminSectionSubjectTracksRoute: typeof AppAppAdminSectionSubjectTracksRoute
  AppAppAdminSectionTestAssignmentsRoute: typeof AppAppAdminSectionTestAssignmentsRoute
  AppAppLessonLessonIdRoute: typeof AppAppLessonLessonIdRoute
  AppAppAdminSectionManageCoursesSourcedIdRoute: typeof AppAppAdminSectionManageCoursesSourcedIdRoute
  AppAppAdminSectionManageCoursesCreateRoute: typeof AppAppAdminSectionManageCoursesCreateRoute
  AppAppAdminSectionOrgsSourcedIdRoute: typeof AppAppAdminSectionOrgsSourcedIdRoute
  AppAppAdminSectionUsersSourcedIdRoute: typeof AppAppAdminSectionUsersSourcedIdRoute
  AppAppAdminSectionManageCoursesIndexRoute: typeof AppAppAdminSectionManageCoursesIndexRoute
  AppAppAdminSectionManageEnrollmentsIndexRoute: typeof AppAppAdminSectionManageEnrollmentsIndexRoute
  AppAppAdminSectionOrgsIndexRoute: typeof AppAppAdminSectionOrgsIndexRoute
  AppAppAdminSectionUsersIndexRoute: typeof AppAppAdminSectionUsersIndexRoute
}

const AppAppRouteRouteChildren: AppAppRouteRouteChildren = {
  AppAppCoursesRoute: AppAppCoursesRoute,
  AppAppDailyMetricsRoute: AppAppDailyMetricsRoute,
  AppAppLearningMetricsRoute: AppAppLearningMetricsRoute,
  AppAppMapGrowthReportRoute: AppAppMapGrowthReportRoute,
  AppAppMapProfileRoute: AppAppMapProfileRoute,
  AppAppMapTestRoute: AppAppMapTestRoute,
  AppAppMap_actuals_reportRoute: AppAppMap_actuals_reportRoute,
  AppAppMonthReportRoute: AppAppMonthReportRoute,
  AppAppMyLearningReportRoute: AppAppMyLearningReportRoute,
  AppAppOverall_students_subject_reportRoute:
    AppAppOverall_students_subject_reportRoute,
  AppAppPlacementsRoute: AppAppPlacementsRoute,
  AppAppPlacementsOldRoute: AppAppPlacementsOldRoute,
  AppAppSessionReportRoute: AppAppSessionReportRoute,
  AppAppStudentPlacementReportRoute: AppAppStudentPlacementReportRoute,
  AppAppStudentXpReportRoute: AppAppStudentXpReportRoute,
  AppAppWeekReportRoute: AppAppWeekReportRoute,
  AppAppIndexRoute: AppAppIndexRoute,
  AppAppAdminSectionCredentialsRoute: AppAppAdminSectionCredentialsRoute,
  AppAppAdminSectionManualXpRoute: AppAppAdminSectionManualXpRoute,
  AppAppAdminSectionOnboardingRoute: AppAppAdminSectionOnboardingRoute,
  AppAppAdminSectionRosterRoute: AppAppAdminSectionRosterRoute,
  AppAppAdminSectionSubjectTracksRoute: AppAppAdminSectionSubjectTracksRoute,
  AppAppAdminSectionTestAssignmentsRoute:
    AppAppAdminSectionTestAssignmentsRoute,
  AppAppLessonLessonIdRoute: AppAppLessonLessonIdRoute,
  AppAppAdminSectionManageCoursesSourcedIdRoute:
    AppAppAdminSectionManageCoursesSourcedIdRoute,
  AppAppAdminSectionManageCoursesCreateRoute:
    AppAppAdminSectionManageCoursesCreateRoute,
  AppAppAdminSectionOrgsSourcedIdRoute: AppAppAdminSectionOrgsSourcedIdRoute,
  AppAppAdminSectionUsersSourcedIdRoute: AppAppAdminSectionUsersSourcedIdRoute,
  AppAppAdminSectionManageCoursesIndexRoute:
    AppAppAdminSectionManageCoursesIndexRoute,
  AppAppAdminSectionManageEnrollmentsIndexRoute:
    AppAppAdminSectionManageEnrollmentsIndexRoute,
  AppAppAdminSectionOrgsIndexRoute: AppAppAdminSectionOrgsIndexRoute,
  AppAppAdminSectionUsersIndexRoute: AppAppAdminSectionUsersIndexRoute,
}

const AppAppRouteRouteWithChildren = AppAppRouteRoute._addFileChildren(
  AppAppRouteRouteChildren,
)

interface AppRouteRouteChildren {
  AppAppRouteRoute: typeof AppAppRouteRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAppRouteRoute: AppAppRouteRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AdminRouteRouteChildren {
  AdminCourseProgressRoute: typeof AdminCourseProgressRoute
  AdminLessonRoute: typeof AdminLessonRoute
  AdminPlacementsRoute: typeof AdminPlacementsRoute
  AdminQtiRenderTestRoute: typeof AdminQtiRenderTestRoute
  AdminQtiStimulusRenderRoute: typeof AdminQtiStimulusRenderRoute
  AdminQtiTestRenderRoute: typeof AdminQtiTestRenderRoute
  AdminRosterRoute: typeof AdminRosterRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCaseStandardsDocumentIdRoute: typeof AdminCaseStandardsDocumentIdRoute
  AdminCaseStandardsIndexRoute: typeof AdminCaseStandardsIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminCourseProgressRoute: AdminCourseProgressRoute,
  AdminLessonRoute: AdminLessonRoute,
  AdminPlacementsRoute: AdminPlacementsRoute,
  AdminQtiRenderTestRoute: AdminQtiRenderTestRoute,
  AdminQtiStimulusRenderRoute: AdminQtiStimulusRenderRoute,
  AdminQtiTestRenderRoute: AdminQtiTestRenderRoute,
  AdminRosterRoute: AdminRosterRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminCaseStandardsDocumentIdRoute: AdminCaseStandardsDocumentIdRoute,
  AdminCaseStandardsIndexRoute: AdminCaseStandardsIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  ProtectedRoute: ProtectedRoute,
  QtiEmbedQtiIdRoute: QtiEmbedQtiIdRoute,
  QtiStimulusEmbedQtiIdRoute: QtiStimulusEmbedQtiIdRoute,
  QtiEmbedIndexRoute: QtiEmbedIndexRoute,
  QtiStimulusEmbedIndexRoute: QtiStimulusEmbedIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
const rootServerRouteChildren: RootServerRouteChildren = {
  ApiAuthCallbackServerRoute: ApiAuthCallbackServerRoute,
  ApiAuthLoginServerRoute: ApiAuthLoginServerRoute,
  ApiAuthLogoutServerRoute: ApiAuthLogoutServerRoute,
  ApiAuthResetPasswordServerRoute: ApiAuthResetPasswordServerRoute,
}
export const serverRouteTree = rootServerRouteImport
  ._addFileChildren(rootServerRouteChildren)
  ._addFileTypes<FileServerRouteTypes>()
